// extracted by mini-css-extract-plugin
module.exports = {"input":"billing-address__input1Wk"};